module.exports = __webpack_public_path__ + "static/img/player_ranking_title.42e6f86.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ranking/player_ranking_title.png
// module id = 8tV4
// module chunks = 1